import React from 'react'
import styled from 'styled-components'
import TopHeader from './TopHeader'
import { ColumnFlexDiv, RowFlexDiv } from '../Common/CommonStyle'
import ChatTab from './ChatTab'
import MosiacAssignments from './MosiacAssignments'
import AssignmentsTab from './AssignmentsTab'

const demoAssignments = [
  {
    id: 1,
    name: 'temp',
  },
  {
    id: 2,

    name: 'temp',
  },
  {
    id: 3,

    name: 'temp',
  },
  {
    id: 4,

    name: 'temp',
  },
  {
    id: 5,

    name: 'temp',
  },
  {
    id: 6,

    name: 'temp',
  },
  {
    id: 7,

    name: 'temp',
  },
  {
    id: 8,

    name: 'temp',
  },
  {
    id: 9,

    name: 'temp',
  },
  {
    id: 10,

    name: 'temp',
  },
  {
    id: 11,

    name: 'temp',
  },
  {
    id: 12,

    name: 'temp',
  },
  {
    id: 13,

    name: 'temp',
  },
  {
    id: 14,

    name: 'temp',
  },
  {
    id: 15,

    name: 'temp',
  },
  {
    id: 13,

    name: 'temp',
  },
  {
    id: 14,

    name: 'temp',
  },
  {
    id: 15,

    name: 'temp',
  },
  {
    id: 13,

    name: 'temp',
  },
  {
    id: 14,

    name: 'temp',
  },
  {
    id: 15,

    name: 'temp',
  },
  {
    id: 13,

    name: 'temp',
  },
  {
    id: 14,

    name: 'temp',
  },
  {
    id: 15,

    name: 'temp',
  },
  {
    id: 13,

    name: 'temp',
  },
  {
    id: 14,

    name: 'temp',
  },
  {
    id: 15,

    name: 'temp',
  },
  {
    id: 13,

    name: 'temp',
  },
  {
    id: 14,

    name: 'temp',
  },
]

const MainContent = () => {
  const [mosiacView, setMosiacView] = React.useState(true)
  return (
    <ColumnFlexDiv width='100%' height='100%'>
      <RowFlexDiv width='100%' height='100%' alignItems='flex-start'>
        {/* {mosiacView ? ( */}
        <MosiacAssignments assignments={demoAssignments} />
        {/* ) : (
          <AssignmentsTab assignments={demoAssignments} />
        )} */}
        <ChatTab mosiacView={mosiacView} setMosiacView={setMosiacView} />
      </RowFlexDiv>
    </ColumnFlexDiv>
  )
}
export default MainContent

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`
